module.exports = __webpack_public_path__ + "static/media/header.699ef219.jpg";